import { render, staticRenderFns } from "./serveCompany.vue?vue&type=template&id=3fa8853e&scoped=true&"
import script from "./serveCompany.vue?vue&type=script&lang=js&"
export * from "./serveCompany.vue?vue&type=script&lang=js&"
import style0 from "./serveCompany.vue?vue&type=style&index=0&id=3fa8853e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8853e",
  null
  
)

export default component.exports